import { getFullUrl } from '../../utils';
import { AudioManager } from './AudioManager';

export class SoundAudioController extends AudioManager {
  public static baseGainNode: GainNode;

  private static instanceList: SoundAudioController[] = [];

  private constructor(
    src: string,
    audioConfig: Partial<HTMLAudioElement> = {},
    gainOptions: Partial<GainOptions> = {}
  ) {
    super(
      src,
      SoundAudioController.baseGainNode,
      { ...audioConfig },
      gainOptions
    );
    SoundAudioController.instanceList.push(this);
  }

  public static closeAll() {
    SoundAudioController.instanceList.forEach((instance) => instance.close());
    SoundAudioController.instanceList = [];
  }

  /**
   * Each src only create one instance, so if there are same src without different config,
   * you should use updateAudioConfig to update the config.
   */
  public static getInstance(
    src: string,
    audioConfig: Partial<HTMLAudioElement> = {},
    gainOptions: Partial<GainOptions> = {}
  ) {
    const instance = SoundAudioController.instanceList.find(
      (i) => i.audioUrl === getFullUrl(src)
    );

    if (instance) {
      return instance;
    }

    return new SoundAudioController(src, audioConfig, gainOptions);
  }

  public static override init(isMute = false) {
    super.init();
    if (!SoundAudioController.baseGainNode) {
      SoundAudioController.baseGainNode =
        AudioManager.AUDIO_CONTEXT.createGain();
      SoundAudioController.setIsMute(isMute);
    }
  }

  public static setIsMute(value: boolean) {
    SoundAudioController.setVolumeSmoothly(
      SoundAudioController.baseGainNode,
      value ? 0 : 1
    );
  }
}
